import React from 'react';
import { Button, Form, FormControl, FormGroup, FormLabel } from 'react-bootstrap';

import './AamenitiesPage.css';

function AamenitiesPage(props) {
    return (
        <div>
            <div className={props.cond === 'Amenities Page'?'cardPageHome':'pouf'}>

            <Form>
            <div className='cardPageHome inner-title-wrapper'>
                    <div className='intro-box'>
                        <h4>TOP IMAGE SLIDE</h4>
                    </div>
                <FormGroup className="mb-3">
                    <FormLabel>First slide label</FormLabel>
                    <FormControl type='text' />
                </FormGroup>
                <Form.Group controlId="formFileSm" className="mb-3">
                    <Form.Label>Upload first slide photo</Form.Label>
                    <Form.Control type="file" size="sm" />
                </Form.Group>
                <FormGroup className="mb-3">
                    <FormLabel>Second slide label</FormLabel>
                    <FormControl type='text' />
                </FormGroup>
                <Form.Group controlId="formFileSm" className="mb-3">
                    <Form.Label>Upload Second slide photo</Form.Label>
                    <Form.Control type="file" size="sm" />
                </Form.Group>
                <FormGroup className="mb-3">
                    <FormLabel>Third slide label</FormLabel>
                    <FormControl type='text' />
                </FormGroup>
                <Form.Group controlId="formFileSm" className="mb-3">
                    <Form.Label>Upload third slide photo</Form.Label>
                    <Form.Control type="file" size="sm" />
                </Form.Group>
                
            </div>
                <div className='cardPageHome inner-title-wrapper'>
                        <div className='intro-box'>
                            <h4>FACILITIES</h4>
                        </div>
        {/* 1st facility */}
                    <Form.Group controlId="formFileSm" className="mb-3">
                        <Form.Label>Facility 1 title</Form.Label>
                        <FormControl type='text' />
                    </Form.Group>
                    <FormGroup className="mb-3">
                        <Form.Label>Content 1</Form.Label>
                        <Form.Control as="textarea" rows={3} />
                    </FormGroup>
                    <FormGroup className="mb-3">
                        <Form.Label>Content 2</Form.Label>
                        <Form.Control as="textarea" rows={3} />
                    </FormGroup>
                    <Form.Group controlId="formFileSm" className="mb-3">
                        <Form.Label>Upload facility 1 Photo</Form.Label>
                        <Form.Control type="file" size="sm" />
                    </Form.Group>
        {/* 2nd facility */}
                    <Form.Group controlId="formFileSm" className="mb-3">
                        <Form.Label>Facility 2 title</Form.Label>
                        <FormControl type='text' />
                    </Form.Group>
                    <FormGroup className="mb-3">
                        <Form.Label>Content 1</Form.Label>
                        <Form.Control as="textarea" rows={3} />
                    </FormGroup>
                    <FormGroup className="mb-3">
                        <Form.Label>Content 2</Form.Label>
                        <Form.Control as="textarea" rows={3} />
                    </FormGroup>
                    <Form.Group controlId="formFileSm" className="mb-3">
                        <Form.Label>Upload facility 2 Photo</Form.Label>
                        <Form.Control type="file" size="sm" />
                    </Form.Group>
        {/* 3rd facility */}
                    <Form.Group controlId="formFileSm" className="mb-3">
                        <Form.Label>Facility 3 title</Form.Label>
                        <FormControl type='text' />
                    </Form.Group>
                    <FormGroup className="mb-3">
                        <Form.Label>Content 1</Form.Label>
                        <Form.Control as="textarea" rows={3} />
                    </FormGroup>
                    <FormGroup className="mb-3">
                        <Form.Label>Content 2</Form.Label>
                        <Form.Control as="textarea" rows={3} />
                    </FormGroup>
                    <Form.Group controlId="formFileSm" className="mb-3">
                        <Form.Label>Upload facility 3 Photo</Form.Label>
                        <Form.Control type="file" size="sm" />
                    </Form.Group>

                </div>
                {/* <div className='cardPageHome inner-title-wrapper'>
                    <div className='intro-box'>
                        <h4>ROOM TYPES</h4>
                    </div>
                    <FormGroup className="mb-3">
                        <FormLabel>Room1 Name</FormLabel>
                        <FormControl type='text' />
                    </FormGroup>
                    <Form.Group controlId="formFileSm" className="mb-3">
                        <Form.Label>Upload Room1 Photo </Form.Label>
                        <Form.Control type="file" size="sm" />
                    </Form.Group>
                    <FormGroup className="mb-3">
                        <FormLabel>Room2 Name</FormLabel>
                        <FormControl type='text' />
                    </FormGroup>
                    <Form.Group controlId="formFileSm" className="mb-3">
                        <Form.Label>Upload Room2 Photo </Form.Label>
                        <Form.Control type="file" size="sm" />
                    </Form.Group>
                    <FormGroup className="mb-3">
                        <FormLabel>Room3 Name</FormLabel>
                        <FormControl type='text' />
                    </FormGroup>
                    <Form.Group controlId="formFileSm" className="mb-3">
                        <Form.Label>Upload Room3 Photo </Form.Label>
                        <Form.Control type="file" size="sm" />
                    </Form.Group>
                </div> */}
                {/* <div className='cardPageHome inner-title-wrapper'>
                    <div className='intro-box'>
                        <h4>TESTIMONIALS</h4>
                    </div>
                    <FormGroup className="mb-3">
                        <FormLabel>Testimonial Title</FormLabel>
                        <FormControl type='text' />
                    </FormGroup>
                    <FormGroup className="mb-3">
                        <Form.Label>Testimonial Message</Form.Label>
                        <Form.Control as="textarea" rows={3} />
                    </FormGroup>
                </div> */}
                <div className='intro-box'>
                    <Button variant='secondary' type='submit'>UPDATE</Button>
                </div>
            </Form>
            </div>
        </div>
    )
}

export default AamenitiesPage
